import { baseUrl } from "../common/config";
import { http } from "../common/helpers/index";
import { ApiResponse } from "../models/api/api-response";

interface ParticipantHighlightsApi {
  totalRecords: number;
  data: HighlightApi[];
}

interface HighlightApi {
  id: number;
  title: string;
  note: string;
  type: string;
  createdAt: string;
}

interface getHighlightsParams {
  keyword?: string;
  pageNumber: number;
  pageSize: number;
  orderBy?: string;
  sortOrder?: string;
}

export const getParticipantHighlights = async ({
  ...params
}: getHighlightsParams) => {
  const { data } = await http.get<ApiResponse<ParticipantHighlightsApi>>(
    `${baseUrl}/api/assessments/highlights-gameplan`,
    { params }
  );
  return data.data;
};
